import { render, staticRenderFns } from "./CollapsableMessages.vue?vue&type=template&id=4cb3e9d9&scoped=true&lang=pug"
import script from "./CollapsableMessages.vue?vue&type=script&lang=js"
export * from "./CollapsableMessages.vue?vue&type=script&lang=js"
import style0 from "./CollapsableMessages.vue?vue&type=style&index=0&id=4cb3e9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3e9d9",
  null
  
)

export default component.exports